import React, {useContext, useEffect, useState} from 'react';
import {Button} from 'antd';
import DeleteComponent from '../common/DeleteComponent';
import EditComponent from '../common/EditComponent';
import SearchMemberModal from '../common/SearchMemberModal';
import {Arguments} from '../common/Arguments';
import {sideMenuContext} from '../../../router/IndexRouter';
import {GetApiMethod} from '../common/ApiMethod';
import TableComponent from '../common/TablePaginationComponent';
import {camelObj} from '../common/ConversionMethod';
import SearchBox from '../common/SearchBoxComponent';
import {SortByZhiWu} from '../common/SortListByPost';

export default function GroupBranchMembers() {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const currentUrl = window.location.href;
	const {dataSource, setDataSource, setCopyDataSource} = useContext(sideMenuContext);
	const getApi = Arguments.host + '/society_organization/base/branch/api!branchPartyBranchMembers.do';

	useEffect(() => {
		setDataSource([]);
		GetApiMethod({getApi, setDataSource, setCopyDataSource});
	}, [getApi]);

	const columns = [
		{
			title: '序号',
			dataIndex: 'showIndex',
			width: 100,
			sorter: (a, b) => a.showIndex - b.showIndex,
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '姓名',
			dataIndex: 'member_name',
			width: 100,
		},
		{
			title: '出生日期',
			dataIndex: 'member_born',
			width: 120,
		},
		{
			title: '工作单位（或原）',
			responsive: ['lg'],
			dataIndex: 'member_unit',
			width: 160,
		},
		{
			title: '入党时间',
			responsive: ['lg'],
			dataIndex: 'member_date',
			width: 120,
		},
		{
			title: '党内职务',
			dataIndex: 'party_post',
			width: 120,
		},
		{
			title: '学会内职务',
			dataIndex: 'organization_post',
			width: 120,
		},
		{
			title: '组织关系所在单位',
			responsive: ['lg'],
			dataIndex: 'member_zzgx_unit',
			width: 180,
		},
		{
			title: '操作',
			width: 140,
			render: (item) => (
				<>
					<EditComponent item={camelObj(item)} url={currentUrl}/>
					<DeleteComponent
						item={item}
						postApi={[
							Arguments.host + '/society_organization/base/branch/api!addBranchPartyBranchMember.do']}
						getApi={getApi}
					/>
				</>
			),
		},
	];

	const showModal = () => {
		setIsModalOpen(true);
	};

	const indexDataSource = SortByZhiWu(dataSource).map((data, index) => ({showIndex: index + 1, ...data}));

	return (
		<>
			<Button type="primary" onClick={() => showModal()}
					style={{marginBottom: 10}}>新增</Button>
			<SearchBox/>
			<SearchMemberModal
				isModalOpen={isModalOpen}
				setIsModalOpen={setIsModalOpen}
				titleText="请选择要新增为支部成员的党员"
				searchApi={Arguments.host + '/society_organization/base/branch/api!branchPartyGroup.do'}
			/>
			<TableComponent dataSource={indexDataSource} columns={columns}/>
		</>
	);
}